import { ZoneType } from "@/codegen/openapi2";
import { TextCell } from "@/components/2//text-cell/text-cell";

type CustomerServiceCellProps = {
  zone: ZoneType;
  onUpdate?: (zone: ZoneType, field: string, value: string) => void;
};

export const CustomerServiceCell = ({ zone, onUpdate }: CustomerServiceCellProps) => {
  return (
    <TextCell
      value={zone.customer_service_id}
      onSave={onUpdate ? value => onUpdate(zone, "customer_service_id", value) : undefined}
      type="number"
      placeholder="Service ID"
      nullable={true}
    />
  );
};
